import { catchError } from "rxjs/operators"
import { combineEpics } from "redux-observable"
import { plansEpics } from "./plans"
import { loaderEpics } from "./loader"
import { notificationEpics } from "./notification"
import { calendarViewEpics } from "./calendarView"
import { carOrderEpics } from "./carOrder"
import { resequenceEpics } from "./resequence"
import { visibilityEpics } from "./visibility"
import { userProfileEpics } from "./userProfile"
import { userViewsEpics } from "./userViews"
import { chargeManagementEpics } from "./chargeManagement"
import { generalPlacementsEpics } from "./generalPlacements"
import { emailNotificationsEpics } from "./emailNotifications"
import { switchRequestsEpics } from "./switchRequests"
import { configEpics } from "./config"

const allEpics = Object.values({
    ...plansEpics,
    ...loaderEpics,
    ...notificationEpics,
    ...calendarViewEpics,
    ...carOrderEpics,
    ...visibilityEpics,
    ...resequenceEpics,
    ...userProfileEpics,
    ...userViewsEpics,
    ...chargeManagementEpics,
    ...generalPlacementsEpics,
    ...emailNotificationsEpics,
    ...switchRequestsEpics,
    ...configEpics,
})

const rootEpic = (action$, store$, dependencies) =>
    combineEpics(...allEpics)(action$, store$, dependencies).pipe(
        catchError((error, source) => {
            console.error("Error in api", error)
            return source
        })
    )

export default rootEpic
